import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AdminCardView from 'components/administration/staff/AdminCardView';
import AdminCardEdit from 'components/administration/staff/AdminCardEdit';

const AdminCard = ({ admin, onResetPassword, onArchive, onUpdate, auth }) => {
  const [edit, setEdit] = useState(false);

  return edit ? (
    <AdminCardEdit
      auth={auth}
      admin={admin}
      onResetPassword={onResetPassword}
      onArchive={onArchive}
      onUpdate={onUpdate}
      onCancel={() => setEdit(false)}
    />
  ) : (
    <AdminCardView
      admin={admin}
      onEdit={() => setEdit(true)}
    />
  );
};

AdminCard.propTypes = {
  auth: PropTypes.object.isRequired,
  admin: PropTypes.object.isRequired,
  onResetPassword: PropTypes.func.isRequired,
  onArchive: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default AdminCard;
